import type React from 'react';
import type { CalendarCellRectSnapshot, CalendarPublication, PopoverPosition } from './types';

export const VISIBLE_PUBS_PER_CELL = 4;

export const DAY_LIST_POPOVER_MAX_WIDTH = 400;
const DAY_LIST_POPOVER_MAX_HEIGHT = 400;
const DAY_LIST_POPOVER_GAP = 4;
const CALENDAR_POPOVER_VIEWPORT_MARGIN = 12;

function dayListPopoverMaxHeight(): number {
    return Math.min(window.innerHeight * 0.7, DAY_LIST_POPOVER_MAX_HEIGHT);
}

function dayListPopoverWidth(): number {
    return Math.min(window.innerWidth - 24, DAY_LIST_POPOVER_MAX_WIDTH);
}

export function computeDayListPopoverPosition(anchorRect: DOMRect): PopoverPosition {
    const maxHeight = dayListPopoverMaxHeight();
    const width = dayListPopoverWidth();
    const margin = CALENDAR_POPOVER_VIEWPORT_MARGIN;

    let top = anchorRect.bottom + DAY_LIST_POPOVER_GAP;
    const spaceBelow = window.innerHeight - margin - top;

    if (spaceBelow < maxHeight) {
        const topAbove = anchorRect.top - DAY_LIST_POPOVER_GAP - maxHeight;
        if (topAbove >= margin) {
            top = topAbove;
        } else {
            top = Math.max(margin, window.innerHeight - margin - maxHeight);
        }
    }

    const left = Math.max(margin, Math.min(anchorRect.left, window.innerWidth - width - margin));

    return { top, left };
}

export const EMPTY_PUBLICATIONS: readonly CalendarPublication[] = [];

const CALENDAR_DAY_CELL_SELECTOR = '[data-calendar-day-cell]';

export function snapshotRectFromClosest(
    event: React.MouseEvent<HTMLElement>,
    selector: string,
): CalendarCellRectSnapshot | undefined {
    const target = event.currentTarget.closest(selector);
    if (!(target instanceof HTMLElement)) {
        return undefined;
    }
    const rect = target.getBoundingClientRect();
    return { left: rect.left, top: rect.top, width: rect.width, height: rect.height };
}

export function snapshotCellRectFromEvent(
    event: React.MouseEvent<HTMLElement>,
): CalendarCellRectSnapshot | undefined {
    return snapshotRectFromClosest(event, CALENDAR_DAY_CELL_SELECTOR);
}
